<template>
  <b-tooltip
    :delay="{ show: showDelay, hide: hideDelay }"
    :target="target"
    :placement="placement"
    :triggers="triggers"
    :variant="variant"
    :custom-class="customClass"
    ref="tooltip"
    :boundary="boundary"
  >
    <!-- @slot This contains tooltip content -->
    <slot></slot>
  </b-tooltip>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'

/**
 * This is a wrapper component for bootstrap tooltip
 * Main motive behind building this component is to be able to control tooltip from a central place
 */
export default {
  name: 'Tooltip',
  props: {
    target: String,
    showDelay: {
      delay: 500,
      type: Number
    },
    hideDelay: {
      delay: 0,
      type: Number
    },
    placement: {
      default: 'bottom'
    },
    triggers: {
      default: 'hover'
    },
    variant: {
      default: 'default'
    },
    boundary: {
      default: 'scrollParent'
    },
    customClass: {
      default: ''
    }
  },
  components: {
    BTooltip
  },
  methods: {
    open() {
      this.$refs.tooltip.$emit('open')
    },
    close() {
      this.$refs.tooltip.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.b-tooltip:not([style*='transform']) {
  top: 0;
}
</style>
